var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalTokenAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.1 435.2",
    style: {
      enableBackground: "new 0 0 480.1 435.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424,255.2c0-0.8,0-2.4,0-3.2c0-72-42.4-134.4-103.2-164.8c0-2.4,0-4.8,0-7.2c0-44-36-80-80-80s-80,36-80,80 c0,2.4,0,4.8,0,7.2C100,116.8,57.6,180,57.6,252c0,0.8,0,2.4,0,3.2C24.8,264.8,0,295.2,0,332c0,44,36,80,80,80 c17.6,0,34.4-5.6,48-16c31.2,24,70.4,39.2,112,39.2s80.8-14.4,112-39.2c13.6,9.6,29.6,16,48,16c44,0,80-36,80-80 C481.6,296,457.6,264.8,424,255.2z M152.8,368c5.6-11.2,8.8-23.2,8.8-36c0-39.2-28.8-72-66.4-78.4c0-0.8,0-0.8,0-1.6 c0-56,32-104.8,78.4-129.6c14.4,22.4,39.2,37.6,68,37.6s53.6-15.2,68-37.6C356,147.2,388,196,388,252c0,0.8,0,0.8,0,1.6 c-37.6,6.4-66.4,39.2-66.4,78.4c0,12.8,3.2,24.8,8.8,36c-24.8,19.2-55.2,30.4-88.8,30.4S177.6,386.4,152.8,368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTokenAllIcon);
export default __webpack_public_path__ + "static/media/total_token_all_icon.38a667aff6cf9ba077931d7db9f652b0.svg";
export { ForwardRef as ReactComponent };